import axios from "axios";

const baseUrl = process.env.REACT_APP_API_END_POINT_BASE_URL;

const pyUrl = process.env.REACT_APP_API_END_POINT_PY_URL;

export const app = axios.create({
  baseURL: baseUrl,
});

export const upload = axios.create({
  baseURL: pyUrl,
});

app.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      
      if (error?.config?.url !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

app.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authtoken");
    if (Boolean(token)) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

upload.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

upload.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
